<div *ngIf="gallery" [id]="slideType" class="gallery-top" [ngClass]="{'overflow': slideType=='leaderboard'}">
  <div class="content">
    <ngx-glide [animationTimingFunc]="'ease-in-out'"
              [showArrows]="gallery?.length > 1 ? true : false"
              [showBullets]="false"
              [hoverpause]="true"
              [animationDuration]="250"
              [perView]="1"
              [autoplay]="gallery?.length > 1 && autoSlide ? 3000 : false"
              [arrowLeftLabel]="''"
              [arrowRightLabel]="''"
              type="carousel"
            >
      <div [id]="'lightgallery' + slideType" class="" *ngFor="let slide of gallery; let i = index;">
        <span class="swiper-slide img-container">
          <!-- For images -->
          <img loading="lazy" [hidden]="slide.media_type==='video'" class="img" [ngClass]="slideType" [attr.data-src]="slide.cdn_path" [alt]="'Fundraiser Leaderboard'+i" />
          <!-- For Youtube video -->
          <img loading="lazy" [hidden]="!(slide.media_type=='video' && !slide?.showVideo)" class="img"
          [ngClass]="slideType" [attr.data-src]="slide.cdn_path" (click)="addYoutubeEmbed(slide)"
          [alt]="'Fundraiser Leaderboard Youtube Video'+i" />
          <i *ngIf="slide.media_type=='video' && !slide?.showVideo" class="icon-youtube1"
          (click)="addYoutubeEmbed(slide)"></i>
          <!-- Youtube embed -->
          <iframe *ngIf="slide.media_type=='video' && slide?.showVideo" class="youtube-embed b-lazy" [ngClass]="slideType" type="text/html" allow="autoplay" [src]="slide?.videoSrc"></iframe>
          <!-- Under line shadow -->
          <div *ngIf="shadow" class="image-shadow" [ngClass]="{'videos': slide.media_type === 'video'}" [attr.data-bg]="slide.cdn_path"></div>
          <!-- Fundraiser Short Description for desktop-->
          <div class="fr-short-description">
            <div>{{fundraiser?.title}}</div>
          </div>
        </span>
      </div>
    </ngx-glide>
  </div>
</div>
